import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminClaims = () => {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        const res = await axios.get('/api/platform_admin/claims', {
          withCredentials: true,
        });

        if (res.data && res.data.ok) {
          setClaims(Array.isArray(res.data.claims) ? res.data.claims : []);
        } else if (res.data && res.data.redirect) {
          window.location.href = res.data.redirect;
          return;
        } else {
          setClaims([]);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          const redirectUrl =
            err.response.data && err.response.data.redirect
              ? err.response.data.redirect
              : '/platform_admin/login';
          window.location.href = redirectUrl;
          return;
        }

        console.error('클레임 목록 로드 실패:', err);
        setClaims([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClaims();
  }, []);

  const getStatusMeta = (status) => {
    if (status === 'requested') {
      return { badge: 'secondary', text: '요청' };
    } else if (status === 'approved') {
      return { badge: 'primary', text: '승인' };
    } else if (status === 'rejected') {
      return { badge: 'danger', text: '거절' };
    } else if (status === 'completed') {
      return { badge: 'success', text: '완료' };
    }
    return { badge: 'dark', text: status || '' };
  };

  const getTypeText = (type) => {
    if (type === 'exchange') return '교환';
    return '반품';
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  return (
    <div className="bg-light min-vh-100">
      {/* ===== NAVBAR ===== */}
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light active me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light active me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <h4 className="mb-3">🚨 클레임 관리</h4>

        <div className="card shadow-sm">
          <div className="card-body p-0">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>상점</th>
                  <th>주문번호</th>
                  <th>구매자</th>
                  <th>유형</th>
                  <th>상태</th>
                  <th>요청일</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
                {!loading && claims.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      클레임 내역이 없습니다.
                    </td>
                  </tr>
                )}

                {loading && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      불러오는 중...
                    </td>
                  </tr>
                )}

                {!loading &&
                  claims.map((row) => {
                    const statusMeta = getStatusMeta(row.status);
                    const typeText = getTypeText(row.type);

                    return (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>{row.shop_name || '-'}</td>
                        <td>{row.order_id}</td>
                        <td>{row.buyer_name || '-'}</td>
                        <td>{typeText}</td>
                        <td>
                          <span className={`badge bg-${statusMeta.badge}`}>
                            {statusMeta.text}
                          </span>
                        </td>
                        <td>{row.created_at}</td>
                        <td>
                          <a
                            href={`/platform_admin/order_view?id=${row.order_id}`}
                            className="btn btn-sm btn-outline-primary"
                          >
                            주문보기
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminClaims;